import React from "react";
import { Link } from "react-router-dom";

import { Container, Nav, Navbar, Dropdown } from "react-bootstrap";

import { ArrowDown2, Profile2User } from "iconsax-react";

import { ROUTE_AUTHENTICATION, ROUTE_PURCHASE } from "../../../routes";

import logoSticky from "../../../image/logo6.svg";

import links from "../../../utility/content/Links";

import NavProfileListComponent from "../navList";

import {
  NavbarLeft,
  StyledNavLink,
  NavbarRight,
  NavbarLogoImg,
  StyledDropdown,
  StyledNavbarButton,
  StyledDropdownToggle,
  StyledDropdownMenu,
  StyledBadge,
  StyledWalletIcon,
  NavAnchor,
} from "./styledNavbars";

const DesktopNavbarComponent = ({ className, location, user, profileDetails, list }) => {
  return (
    <Container fluid="md" className={className}>
      <NavbarRight className="d-flex">
        <Navbar.Brand className="ps-4 py-0">
          <Link to="/">
            <NavbarLogoImg
              src={logoSticky}
              alt="azeto-main-logo"
              width="140"
              height="36"
            />
          </Link>
        </Navbar.Brand>
        <Nav as="ul" className="d-none d-md-flex align-items-center">
          {links.map((link) => {
            if (link.path) {
              return (
                <StyledNavLink
                  key={link.id}
                  to={link.path}
                  exact
                  className="mx-3 mx-lg-4"
                  activeClassName="active-navbar-link"
                >
                  {link.title}
                </StyledNavLink>
              );
            } else {
              return (
                <NavAnchor
                  key={link.id}
                  href={link.href}
                  target="_blank"
                  className="px-2 px-lg-3"
                >
                  {link.title}
                </NavAnchor>
              );
            }
          })}
        </Nav>
      </NavbarRight>
      <NavbarLeft className="d-flex gap-3" login={user.isLogin}>
        {user.isLogin ? (
          <>
            <StyledDropdown>
              {profileDetails.unreadMessages !== 0 && (
                <StyledBadge pill bg="danger" className="position-absolute">
                  {profileDetails.unreadMessages}
                </StyledBadge>
              )}
              <StyledDropdownToggle variant="transparent" className="gap-1 p-0">
                <img
                  src={profileDetails.image}
                  alt="profile"
                  width="36"
                  height="36"
                  className="rounded-circle"
                />
                <span>{profileDetails.fullName}</span>
                <ArrowDown2 size="14" />
              </StyledDropdownToggle>
              <StyledDropdownMenu className="mt-0">
                <Dropdown.Header>
                  <StyledWalletIcon
                    size="32"
                    color="var(--secondary-color)"
                    variant="Bold"
                  />
                  <p className="m-0">{profileDetails?.balance?.toLocaleString()} تومان</p>
                </Dropdown.Header>
                <NavProfileListComponent list={list} />
              </StyledDropdownMenu>
            </StyledDropdown>
            <StyledNavbarButton to={ROUTE_PURCHASE}>اشتراک</StyledNavbarButton>
          </>
        ) : (
          <>
            <StyledNavbarButton to={ROUTE_PURCHASE}>اشتراک</StyledNavbarButton>
            <StyledNavbarButton
              $bgPrimary
              className="px-lg-2"
              to={{
                pathname: ROUTE_AUTHENTICATION,
                state: { prevPath: location.pathname },
              }}
            >
              <Profile2User size="20" />
              &nbsp;ورود | ثبت‌نام
            </StyledNavbarButton>
          </>
        )}
      </NavbarLeft>
    </Container>
  );
};

export default DesktopNavbarComponent;
